export type StaticVendor = {
  id: string;
  name: string;
  description: string;
  website?: string;
  imageUrl?: string;
}

export const VENDORS: StaticVendor[] = [
  {
    id: '1',
    name: 'Skadi Jewellery Design',
    description: 'Skadi Jewellery Design creates dark fantasy inspired saw pierced fine jewellery, transforming sterling silver by hand into flattering, empowering and personalised objects of wearable art imbued with stories and secrets.',
    website: 'http://skadijewellery.com/',
  },
  {
    id: '2',
    name: 'Minute Sarah',
    description: 'I sell a variety of colourful, warm, and slightly surreal artwork. Including lots of stationery goodies such as high quality notebooks, washi tape, stickers, and foil art prints!',
    website: 'https://minutesarah.com/',
  },
  {
    id: '3',
    name: 'Tehriel',
    description: 'Here for all your necromantic needs. Bats, elven vampires, ghosts and ghouls — all the prints, stickers and key chains an undead could need. Look to the flickering candles and cozy but vaguely sinister vibes in the artist alley.',
    website: 'https://tehriel.carrd.co/',
  },
  {
    id: '4',
    name: 'Scarlet Song',
    description: 'Will be selling and promoting Cottage Core Critters: A Cosy Critter RPG & its expansion Seasons of Stories.',
    website: 'http://www.scarletsong.com.au',
  },
  {
    id: '5',
    name: 'Of Aissance',
    description: 'Of Aissance celebrates the whimsical intersection of folklore and fantasy, creating handmade goods that invite people into worlds of escapism and wonder. Wire-wrapped jewellery and accessories, TTRPG one-shots, zines, greeting cards, potions, prints, stickers and other upcycled trinkets.',
    website: 'https://www.instagram.com/ofaissance',
  },
  {
    id: '6',
    name: 'Hag.made',
    description: 'Handmade by your local hag, Marissa works with both metal and yarn to create jewellery, tapestries and accessories with a gothic, fantastical sensibility. From crochet medieval weapon rattles to the spiky freshwater pearl chainmail set of your dreams — the perfect piece of queer gothic glamour.',
    website: 'https://www.instagram.com/hag.made',
  },
  {
    id: '7',
    name: 'The Murmuring Mystic',
    description: 'We make tiny games and even tinier trinkets 😊',
    website: 'https://www.instagram.com/themurmuringmystic/',
  },
  {
    id: '8',
    name: 'Shaille Chainmaille',
    description: 'A modern take on the ancient art of Chainmaille. Individual metal rings are woven to create beautifully intricate Chainmaille and Scalemaille jewellery, decor, and accessories.',
    website: 'http://www.shaillechainmaille.com.au',
  },
  {
    id: '9',
    name: 'Bathyal Labs',
    description: 'Handcrafted dice and journals for the player, Master Dice and molds for the maker — and a mission for inclusivity. We turn "if you can dream it" into physical reality. Whether you are looking for a new heirloom set, professional-grade maker tools, or a custom commission, stop by for a chat.',
    website: 'http://www.bathyallabs.com',
  },
  {
    id: '10',
    name: 'Cycorg',
    description: 'Selling Medieval inspired risograph prints, stickers & wearables, as well as original Pyrography pieces.',
    website: 'https://www.instagram.com/cycorg/',
  },
  {
    id: '11',
    name: 'Clickity Clackity Cube',
    description: 'The home of some proud nerds who have a passion for creating dice for themselves and others. You\'re bound to find a set of homemade dice that you\'ll love — and if you don\'t, you can make your own!',
    website: 'https://www.clickityclackitycube.com/',
  },
  {
    id: '12',
    name: 'Australian Roleplay Community',
    description: 'Selling games published by the ARC Creative Collective.',
    website: 'https://www.arcrpg.org/',
  },
];
